/**
 * Analytics shim (Valkyrie port).
 *
 * eb-ui called `@eventbrite/site-analytics` `trackAnalyticsEvent`, which fed
 * Google Analytics. GA is deprecated in favour of Heap (see memory.md), so we
 * forward the same category/action/label to `window.heap.track` when present.
 * It is a guarded no-op when Heap has not loaded (SSR, tests, consent not
 * granted) — faithful to eb-ui's `if (ga)` guard.
 */
export interface AnalyticsEvent {
    action: string;
    category: string;
    label?: string;
    value?: number;
}

interface HeapWindow extends Window {
    heap?: {
        track: (event: string, properties?: Record<string, unknown>) => void;
    };
}

export const trackAnalyticsEvent = (event: AnalyticsEvent): void => {
    try {
        if (typeof window === 'undefined') {
            return;
        }

        const { heap } = window as HeapWindow;
        if (!heap || typeof heap.track !== 'function') {
            return;
        }

        heap.track(event.action, {
            category: event.category,
            label: event.label,
            value: event.value,
        });
    } catch {
        // Analytics must never break the widget.
    }
};
